import configureStore from 'redux-mock-store';

const mockStore = configureStore([]);

export const getMockStore = (mockState: unknown) => {
  const store = mockStore(mockState);
  store.dispatch = jest.fn();

  return store;
};

type Node = { textContent: string };
type NodeQuery = { children: Node[]; textContent: string };
export const withMarkup = (query: Function) => (text: string) =>
  query((_content: unknown, nodeQuery: NodeQuery) => {
    const hasText = (node: Node | NodeQuery) => node.textContent === text;
    const childrenDontHaveText = Array.from(nodeQuery.children).every((child) => !hasText(child));
    return hasText(nodeQuery) && childrenDontHaveText;
  });
